export const entityMatchingId = <T>(
  entity: T | null | undefined,
  entityId: string | null | undefined,
  expectedId: string | null | undefined,
): T | undefined => (entity && expectedId && entityId === expectedId ? entity : undefined);

export default entityMatchingId;
